import Reveal from "@/components/motion/Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq({ items, title = "Häufige Fragen", subtitle }) {
  return (
    <section className="relative bg-[#080808] py-24 sm:py-32" data-testid="faq">
      <div className="mx-auto max-w-[900px] px-5 sm:px-8">
        <Reveal className="mb-12 text-center">
          <p className="mb-4 font-body text-[11px] font-bold uppercase tracking-[0.3em] text-volt">FAQ</p>
          <h2 className="font-heading text-4xl font-black uppercase leading-[0.9] tracking-tight text-white sm:text-5xl">
            {title}
          </h2>
          {subtitle && <p className="mt-4 font-body text-neutral-400">{subtitle}</p>}
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-5 text-left font-heading text-xl font-bold uppercase text-white hover:no-underline hover:text-volt [&[data-state=open]]:text-volt">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-body text-base leading-relaxed text-neutral-400">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
